import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {geoUtils} from '../utils/geo-utils';
import {createSelector} from "reselect";

/**
 * Component for drawing the colored county shapes of the selected state map.
 *
 * This component is only responsible for drawing the color classified shapes of
 * the svg map, the borders and hovers are handled by other components.
 *
 * The color of each shape is determined by the data and the quartile of the county
 * using the geoUtils.createQuartileFillScale
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property stateFips - numeric state fips value to retrieve state county shapes
 * @property data - array of location models to calculate the legend values
 * @property dict - dictionary of data keyed by the county fips
 * @property dimension - field in data objects that holds the quartile value for classification
 *
 * @example
 * return (
 *   <StateCountyShapes
 *     width={500}
 *     height={500}
 *     stateFips={1}
 *     data={[...]}
 *     dict={{...}}
 *     dimension={'quartile'}
 *   />
 * )
 */
export default class StateCountyShapes extends PureComponent {

  static propTypes = {
    stateFips: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    data: PropTypes.array,
    dict: PropTypes.object,
    dimension: PropTypes.string
  }

  getFips = (props) => props.stateFips
  getWidth = (props) => props.width
  getHeight = (props) => props.height
  getData = (props) => props.data
  getDict = (props) => props.dict
  getDimension = (props) => props.dimension

  getPaths = createSelector(
    [this.getFips, this.getWidth, this.getHeight],
    (fips, width, height) => geoUtils.getMercatorStateCountyPaths(fips, width, height)
  )

  getScale = createSelector(
    [this.getData, this.getDimension],
    (data, dimension) => geoUtils.createQuartileFillScale(data, dimension)
  )

  getShapes = createSelector(
    [this.getPaths, this.getScale, this.getDict],
    (paths, scale, dict) => {
      const getValue = d => _.get(dict, d.id, {});
      return paths.map(d => (
        <path
          key={d.id}
          d={d.path}
          fill={scale(getValue(d))}
        />
      ))
    }
  )

  render() {
    const shapes = this.getShapes(this.props);

    return (
      <g className="StateCountyShapes">
        {shapes}
      </g>
    )
  }
}
